module.exports = __webpack_public_path__ + "img/culemborg-logo.6f625e96.png";